var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 18,
    viewBox: "0 0 6 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7451 4.74581L3.41205 7.07885C3.29812 7.19279 3.14913 7.24888 3.00013 7.24888C2.85114 7.24888 2.7004 7.19279 2.58646 7.07885L0.253422 4.74581C0.025552 4.51794 0.025552 4.14809 0.253422 3.92022C0.481292 3.69253 0.851143 3.69253 1.07901 3.92022L2.41644 5.25764V0.833454C2.41644 0.511105 2.67761 0.249756 3.00013 0.249756C3.32266 0.249756 3.58383 0.511105 3.58383 0.833454V5.25764L4.92126 3.92022C5.14913 3.69253 5.51723 3.69253 5.7451 3.92022C5.97297 4.14809 5.97297 4.51794 5.7451 4.74581ZM5.7451 13.2541L3.41205 10.9211C3.18418 10.6932 2.81433 10.6932 2.58646 10.9211L0.253422 13.2541C0.025552 13.482 0.025552 13.8501 0.253422 14.0782C0.367357 14.1919 0.51635 14.2498 0.667095 14.2498C0.816087 14.2498 0.965078 14.1919 1.07901 14.0782L2.41644 12.7406V17.1665C2.41644 17.489 2.67761 17.7502 3.00013 17.7502C3.32266 17.7502 3.58383 17.489 3.58383 17.1665V12.7406L4.92126 14.0782C5.14913 14.3058 5.51723 14.3058 5.7451 14.0782C5.97297 13.8501 5.97297 13.482 5.7451 13.2541Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseAll);
export default __webpack_public_path__ + "static/media/collapse-all.4bad80aefe1962a691f378fba376e84a.svg";
export { ForwardRef as ReactComponent };